import { render } from "./index.vue?vue&type=template&id=4796fac7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scForm/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4796fac7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4796fac7', __exports__)) {
    api.reload('4796fac7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4796fac7", () => {
    api.rerender('4796fac7', render)
  })

}


export default __exports__